<template>
  <div v-show="config.show" v-finger:swipe="onSwipe" class="my-container">
    <div v-show="!isDesktop" class="header">
      <div class="left">
        <!-- <el-button class="tap-btn" @click="goto()">
          <i class="iconfont my-back" />
        </el-button> -->
        &nbsp;
      </div>
      <div class="middle">
        <el-button-group>
          <el-button size="small" :type="'primary'" @click="goto('works')">{{ $t('i.works') }}</el-button>
          <el-button size="small" :type="'plain'">{{ $t('i.album') }}</el-button>
          <!-- 专辑 -->
        </el-button-group>
      </div>
      <div class="right" />
    </div>
    <div class="tabs" :style="isDesktop ? 'top: 4px' : ''">
      <el-col :span="16">
        <el-tabs v-model="config.type">
          <el-tab-pane v-for="(type, idx) in types" :key="idx" :label="type[1]" :name="type[0]" />
        </el-tabs>
      </el-col>
      <el-col :span="8" class="filter">
        <el-button class="tap-btn" @click="emit('openSift', ['album'])">
          {{ config.catalogName }}
          <i class="iconfont my-filter" />
        </el-button>
      </el-col>
    </div>
    <album-list
      v-show="config.show && config.type === 'new'"
      ref="album-new"
      mod="new"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <album-list
      v-show="config.show && config.type === 'hot'"
      ref="album-hot"
      mod="hot"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <album-list
      v-show="config.show && config.type === 'best'"
      ref="album-best"
      mod="best"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <album-list
      v-show="config.show && config.type === 'original'"
      ref="album-original"
      mod="original"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
  </div>
</template>
<script>
import albumList from '@/components/web/albumList'
import { mixins } from '@/mixins/common'
export default {
  components: {
    albumList
  },
  mixins: [mixins],
  data() {
    const data = {}
    data.swipeLock = false
    return data
  },
  computed: {
    config() {
      return this.view.album
    },
    types() {
      return this.config.types()
    }
  },
  methods: {
    handle(act, data) {
      if (act === 'setLockSwipe') {
        this.swipeLock = data[0]
      } else {
        this.emit(act, data)
      }
    },
    onSwipe(evt) {
      if (this.swipeLock) return
      this.switchTab(this.config, evt.direction, false)
    },
    renewView() {
      const el = this.$refs['album-' + this.config.type]
      if (el) el.renewView()
    }
  }
}
</script>
